import { InfinityIcon } from "lib/icons";
import { DragPreviewBox } from "./dragPreviewBox";

export const AssetDragPreview = ({ styles }) => (
  <DragPreviewBox icon={InfinityIcon} styles={styles} title="Single item" count={1} />
);
